import {
  deleteMatterSignatureRequestV2,
  fulfillMatterSignatureRequestPublicV2,
  updateMatterSignatureRequestV2,
} from "@/lib/data/requests/matters/matter-signature-request";
import { queryKeys } from "@/lib/data/static/query-keys";
import { type APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";

export const useUpdateSignatureRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMatterSignatureRequestV2,

    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error updating signature request");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Signature request updated successfully");
    },
  });
};

export const useDeleteSignatureRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMatterSignatureRequestV2,
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting signature request");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Signature request deleted successfully");
    },
  });
};

export const useFulfillSignatureRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fulfillMatterSignatureRequestPublicV2,
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error fulfilling signature request");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.signatureRequests],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Signature request fulfilled successfully");
    },
  });
};
